import { Loadable } from '../../../Loadable';

export const AsyncAddPartnerLocation = Loadable(() => import('./Add'));
export const AsyncEditPartnerLocation = Loadable(() => import('./Edit'));
export const AsyncPartnerLocationList = Loadable(() => import('./List'));
export const AsyncViewPartnerLocationMenu = Loadable(() => import('./ViewPartnerLocationMenu'));
